<template>
  <div class="avatar">
    <Tooltip
      :content="
        fullName || `${firstName} ${lastName}` || initials || '' | format
      "
      :disabled="!showTitle"
    >
      <div class="block">
        <el-avatar
          v-if="shape == 'circle'"
          :size="size"
          :src="url"
          :fit="fit"
          :class="(url ? '' : 'circle-empty', size == 40 ? 'avatar-40' : '')"
        >
          <Picture v-if="url" :url="url" />
          <span v-else>{{ (initials || avatarName).toUpperCase() }}</span>
        </el-avatar>
        <el-avatar
          v-else-if="shape == 'square'"
          shape="square"
          :size="144"
          :fit="fit"
          :src="url"
          :class="url ? '' : 'square-empty'"
        >
          <Picture v-if="url" :url="url" />
          <span v-else>{{ (initials || avatarName).toUpperCase() }}</span>
        </el-avatar>
      </div>
    </Tooltip>
  </div>
</template>
<script>
import { Avatar } from 'element-ui';
import Picture from 'Elements/Picture/Picture';
import Tooltip from 'Elements/Tooltip/Tooltip';
import { mixin } from '@/utils/mixins';

export default {
  mixins: [mixin],
  props: {
    fit: { String, default: 'cover' }, // cover
    url: {
      type: String,
      default: ''
    },
    firstName: {
      type: String,
      default: ''
    },
    lastName: {
      type: String,
      default: ''
    },
    fullName: {
      type: String,
      default: ''
    },
    initials: {
      type: String,
      default: ''
    },
    shape: {
      type: String,
      default: 'circle'
    },
    size: {
      type: Number,
      default: 32
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    avatarName() {
      if (this.firstName && this.lastName) {
        return (this.lastName[0] + this.firstName[0]).toUpperCase();
      } else if (this.firstName) {
        return this.firstName[0].toUpperCase();
      } else if (this.lastName) {
        return this.lastName[0].toUpperCase();
      } else if (this.fullName) {
        return (
          this.fullName[0] +
          (this.fullName.indexOf(' ') == -1
            ? ''
            : this.fullName[this.fullName.indexOf(' ') + 1])
        ).toUpperCase();
      } else {
        return '';
      }
    }
  },
  components: {
    'el-avatar': Avatar,
    Picture,
    Tooltip
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  padding: 0;
  margin: 0;
  display: flex;

  & ::v-deep .block {
    display: inherit;
  }

  & ::v-deep img {
    display: block;
    height: 100%;
    // width: auto;
    margin: 0 auto;
  }

  & ::v-deep .el-avatar--square {
    border-radius: 8px;
    font-size: 64px;
    font-weight: 700;
    background: $grey8;
    color: $grey40;
  }

  & ::v-deep .el-avatar--circle {
    font-size: 14px;
    font-weight: 600;
    background: $grey8;
    color: $grey40;
  }

  & ::v-deep.square-empty {
    border: 1px solid $grey8;
    font-weight: 700;
    font-size: 64px;
    line-height: 75px;
    color: $grey16;
  }

  & ::v-deep .circle-empty {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }

  & ::v-deep .avatar-40 {
    font-size: 18px;
    line-height: 28px;
  }
}
</style>
